import React from 'react';
import GridTable from '@nadavshaar/react-grid-table';
import { gridTexts } from '../BarometroDetailsScreen';
import { NavLink } from 'react-router-dom';
import { UserAvatarInfo } from '../../components/UserList';

const EmbrapaSuinosScreen = ({ users }) => {
  return <GridTable texts={gridTexts} columns={columns} rows={users} />
}

const columns = [
  {
    id: 1,
    field: 'name',
    label: 'Nome',
    width: 'calc(100% - 340px)',
    cellRenderer: ({ data }) => <div className='rgt-cell-inner rgt-text-truncate'>
      <UserAvatarInfo padding row={{ ...data, phone: false }} />
    </div>
  },
  {
    id: 2,
    field: 'phone',
    label: 'Contato',
    width: '200px'
  },
  {
    id: 3,
    field: 'ver',
    label: 'Ver',
    width: '120px',
    cellRenderer: ({data}) => <div className='rgt-cell-inner rgt-text-truncate'>
      <NavLink to={`/suinos-details/${data.id}`}>Visualizar</NavLink>
    </div>
  }
];

export default EmbrapaSuinosScreen;